(function () {
	'use strict';
	var controllerId = 'cndProgettoAdd';

	angular.module('app').controller(controllerId, ['$scope', 'common', '$uibModalInstance', 'datacontext', '_', 'cndCandidature', 'cndTRuoloCodes', 'cndTMisuraCodes', 'cndProgettiNames', 'Default', fn_cndProgettoAdd]);

	function fn_cndProgettoAdd($scope, common, $uibModalInstance, datacontext, _, cndCandidature, cndTRuoloCodes, cndTMisuraCodes, cndProgettiNames, Default) {
	    var getLogFn = common.logger.getLogFn;
	    var log = getLogFn(controllerId);
		$scope.record = {};
		$scope.popupTitle = 'Nuovo Progetto';
		$scope.action = 'Add';

		$scope.cndCandidature = cndCandidature;
		$scope.record.iTipoCandidatura = 4;
		change_candidatura($scope.record.iTipoCandidatura);
		$scope.change_candidatura = change_candidatura;

		$scope.cndTRuoloCodes = cndTRuoloCodes;
		$scope.cndTMisuraCodes = cndTMisuraCodes;
		$scope.cndProgettiNames = cndProgettiNames;

		$scope.record.LogoHeader = '/Content/images/fse_top.png';
		$scope.record.LogoHeaderPDF1 = '/Content/images/PDFfse2020.jpg';


		if (Default == 'avviso5') {
			$scope.record.Progetto = 'Lav1_FORM_Partecipazione';
			$scope.record.TRuoloCode = 'AZD_FORM-LAV1';
			$scope.record.TMisuraCode = 'FORM_LAV1';
			$scope.record.DtStart = new Date();
			$scope.record.DtEnd = new Date(moment($scope.record.DtStart).add('d', 15));
			$scope.record.PDFTemplate1 = '/HtmlTemplate/Candidature/Accreditamento/GOL_Partecipazione_AZD_FORM-LAV1_Ricevuta.htm';
		}

	    //Impostazioni per calendario dateTimePicker
		$scope.datepickers = {};
		$scope.today = function () {
			$scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function () {
			$scope.dt = null;
		};

		// Disable weekend selection
		$scope.disabled = function (date, mode) {
			return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
		};

		$scope.toggleMin = function () {
			$scope.minDate = $scope.minDate ? null : new Date();
		};
		$scope.toggleMin();
		$scope.dateOptions = {
			formatYear: 'yyyy',
			formatMonth: 'MM',
			startingDay: 1
		};

		$scope.openCalendar = function ($event, iOpened) {
			$event.preventDefault();
			$event.stopPropagation();

			$scope.opened1 = false;
			$scope.opened2 = false;
			if (iOpened == 1)
			    $scope.opened1 = true;
			if (iOpened == 2)
			    $scope.opened2 = true;
		};

		$scope.clear = function ($event, iOpened) {
		    if (iOpened == 1) {
		        $scope.record.DtStart = '';
		        $scope.changed = true;
		    }
		    else if (iOpened == 2) {
				$scope.record.DtEnd = '';
		        $scope.changed = true;
		    }
		};

		$scope.ok = function (isValid) {
		    if (isValid) {
		        
			    var result = addItem($scope.record)
				$uibModalInstance.close(result);
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};


        function addItem(item) {
			return datacontext.cndProgetto_add(item).then(function (data) {
				return data;
			});		    
		}

		function change_candidatura(cndId) {
			console.info('change_candidatura', cndId);
			$scope.record.ControllerCandidatura = '';
			if (cndId && cndId > 0) {
				var cnd = _.find($scope.cndCandidature, function (o) { return o.Id == cndId; });
				console.info('cnd', cnd);
				if (cnd) {					
					$scope.record.ControllerCandidatura = cnd.Name;
				}
			}
		}

	}
})();